import { cn } from '@/shared/lib'

type Props = {
  html: string
  className?: string
}

export const FAQAnswer = ({ html, className }: Props) => (
  <p
    className={cn(
      '[&_a]:cursor-pointer [&_a]:text-gray-500 [&_a]:underline',
      '[&_a]:rounded-md [&_a]:focus-visible:ring-2 [&_a]:focus-visible:ring-gray-200 [&_a]:focus-visible:outline-none',
      className,
    )}
    dangerouslySetInnerHTML={{ __html: html }}
  />
)
